import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import QuickNav from "./components/QuickNav";
import PlotOverview from "./components/PlotOverview";
import EndingSection from "./components/EndingSection";
import EndingTabs from "./components/EndingTabs";
import EpisodeGuide from "./components/EpisodeGuide";
import LatestUpdates from "./components/LatestUpdates";
import Characters from "./components/Characters";
import Themes from "./components/Themes";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <QuickNav />
        <PlotOverview />
        <EndingSection />
        <EndingTabs />
        <EpisodeGuide />
        <LatestUpdates />
        <Characters />
        <Themes />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
    </div>
  );
}